<template>
  <v-container fluid class="fill-height align-start">
    <Loading v-if="loading" />
    <div v-else class="fill-width withdrawal-details pa-2">
      <v-row
        class="fill-width flex-column ma-0"
        align="center"
        justify="center"
      >
        <v-img
          v-if="withdrawalDetails.logo"
          width="94"
          height="94"
          contain
          :src="withdrawalDetails.logo"
        ></v-img>
        <!--      <v-tooltip top color="primary">-->
        <!--        <template v-slot:activator="{ on, attrs }">-->
        <!--          <v-icon small color="blue" v-bind="attrs" v-on="on" class="mt-4"-->
        <!--            >mdi-information-outline</v-icon-->
        <!--          >-->
        <!--        </template>-->
        <!--        <span>{{ $t("panel.transactionPage.withdrawal.details.tooltip") }}</span>-->
        <!--      </v-tooltip>-->
        <v-card-title
          >{{ $t("panel.transactionPage.withdrawal.details.title") }}
          {{ withdrawalDetails.cryptoAmount }}</v-card-title
        >
        <v-chip
          label
          :color="
            $transactionStatusColor(withdrawalDetails.transactionStatus).color
          "
          :text-color="
            $transactionStatusColor(withdrawalDetails.transactionStatus)
              .textColor
          "
          class="text-center"
          >{{ withdrawalDetails.transactionStatus }}</v-chip
        >
        <!--      <v-card-actions>-->
        <!--        <v-btn color="primary" class="elevation-0">{{-->
        <!--          $t("panel.transactionPage.withdrawal.details.checkStatus")-->
        <!--        }}</v-btn>-->
        <!--      </v-card-actions>-->
        <v-card class="align-self-start fill-width" elevation="0">
          <ul
            v-for="item in $t(
              'panel.transactionPage.withdrawal.details.cardTitle'
            )"
            :key="item.value"
            class="px-0 details"
          >
            <v-card class="d-flex align-center justify-start" elevation="0">
              <v-card-text class="width-auto pe-1 text-no-wrap">{{
                item.text
              }}</v-card-text>
              <v-tooltip
                v-if="item.tooltip"
                top
                color="primary"
                class="width-auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="blue" v-bind="attrs" v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
              <v-card-text
                v-if="!item.condition"
                class="width-auto font-medium-16 gray10--text ml-auto text-right details-value"
                ><span v-if="item.value !== 'transactionTime'">{{
                  withdrawalDetails[item.value]
                }}</span
                ><span v-else>{{
                  withdrawalDetails[item.value] | $renderDate
                }}</span></v-card-text
              >
              <a
                v-else
                :href="withdrawalDetails[item.value]"
                target="_blank"
                class="external-link d-block ml-auto"
              >
                <span class="text-decoration-underline font-semiBold-16">{{
                  item.valueText
                }}</span>
                <v-icon small icon color="primary" class="ms-1"
                  >mdi-open-in-new</v-icon
                >
              </a>
            </v-card>
            <v-divider class="mx-4" />
          </ul>
        </v-card>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { transactionsService } from "@/services";
import renderDate from "@/mixins/renderDate";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import Loading from "@/components/Common/Loading";

export default {
  name: "withdrawal-details",
  components: { Loading },
  props: ["transactionId"],
  mixins: [renderDate, tableStatusItemColor],
  data() {
    return {
      withdrawalDetails: {},
      loading: false
    };
  },
  created() {
    this.getWithdrawTrxDetails();
  },
  methods: {
    getWithdrawTrxDetails() {
      this.loading = true;
      transactionsService
        .getWithdrawTrxById(this.transactionId)
        .then(response => {
          this.withdrawalDetails = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "WithdrawalDetails";
</style>
